import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = window.setTimeout(() => {
      navigate("/", { replace: true });
    }, 800);
    return () => window.clearTimeout(t);
  }, [navigate]);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-8">
      <p className="text-muted-foreground">Accesso in corso…</p>
    </div>
  );
}
